<template>
  <div class="progress">
    <div class="handle-progress">办理流程</div>
    <div class="process-list">
      <div
        class="item"
        v-bind:key="index"
        v-for="(progress, index) in progress"
      >
        <div class="title" v-text="progress.title"></div>
        <div class="content" v-text="progress.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'handleProgress',
  props: ['progress'],
};
</script>
<style>
body {
  counter-reset: order;
}
</style>

<style scoped>
.progress {
  background-color: #fff;
  padding: 0.2rem 0.1rem;
  border-top: 0.15rem solid #f3f4f6;
}

.handle-progress {
  padding-bottom: 0.2rem;
  font-size: 0.14rem;
  text-align: center;
  color: #6f6f6f;
}

h2 {
  font-size: 15px;
  font-weight: bold;
  margin: 20px auto;
  text-align: center;
  color: #6f6f6f;
}

.process-list {
  overflow: visible;
}

.item {
  padding-left: 25px;
  position: relative;
  overflow: visible;
}

.title {
  font-size: 15px;
  color: #444444;
  height: 17px;
  line-height: 17px;
  overflow: visible;
}

.content {
  font-size: 14px;
  color: #777777;
  line-height: 1.8;
  padding: 6px 10px 15px 0;
  position: relative;
}

.item::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 9px;
  border-left: 1px dotted #ff8585;
  z-index: 100;
}

.item:last-of-type::before {
  display: none;
}

.item:last-of-type .content {
  padding-bottom: 0;
}

.title::before {
  content: '';
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 0px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background-color: #ff8585;
  z-index: 200;
}

.title::after {
  counter-increment: order;
  content: counter(order);
  position: absolute;
  top: 0px;
  bottom: 0;
  left: 0px;
  width: 16px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  color: white;
  z-index: 300;
  font-size: 14px;
}

.img .txt {
  margin-top: 25px;
  padding: 0 12px;
  font-size: 15px;
  text-align: center;
  color: #333;
  font-weight: bold;
}

.img img {
  width: 80%;
  display: block;
  margin: 15px auto 0 auto;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

progress,
sub,
sup {
  vertical-align: baseline;
}

button,
hr,
input {
  overflow: visible;
}

html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
}

figcaption,
menu,
article,
aside,
details,
figure,
footer,
header,
main,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  display: inline-block;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

a {
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}

a:active,
a:hover {
  outline-width: 0;
}

abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  text-decoration: underline dotted;
}

b,
strong {
  font-weight: bolder;
}

dfn {
  font-style: italic;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

mark {
  background-color: #ff0;
  color: #000;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

img {
  border-style: none;
}

svg:not(:root) {
  overflow: hidden;
}

code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

figure {
  margin: 1em 40px;
}

hr {
  box-sizing: content-box;
  height: 0;
}

button,
input,
select,
textarea {
  font: inherit;
  margin: 0;
}

optgroup {
  font-weight: 700;
}

button,
select {
  text-transform: none;
}

[type='submit'],
[type='reset'],
button,
html [type='button'] {
  -webkit-appearance: button;
}

[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner,
button::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

[type='button']:-moz-focusring,
[type='reset']:-moz-focusring,
[type='submit']:-moz-focusring,
button:-moz-focusring {
  outline: ButtonText dotted 1px;
}

fieldset {
  border: 1px solid silver;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}

textarea {
  overflow: auto;
}

[type='checkbox'],
[type='radio'] {
  box-sizing: border-box;
  padding: 0;
}

[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}

[type='search'] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type='search']::-webkit-search-cancel-button,
[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-input-placeholder {
  color: inherit;
  opacity: 0.54;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}
</style>
